import httpService from "./httpService";

export default {
  getWorkspaceApps() {
    return httpService.get(`/user/getWorkspaceApps`);
  },
  getTenantLogo() {
    return httpService.get('/user/getTenantLogo')
  }
};



// WEBPACK FOOTER //
// ./src/services/getWorkspaceAppsService.js